export const LOGIN_ROUTE = "/login";
export const REGISTRATION_ROUTE = "/registration";
export const UPLOAD_ROUTE = "/upload";
export const MAIN_ROUTE = "/base";
export const USERS_ROUTE = "/users";
export const REPORT_ROUTE = "/report";
export const REPORTS_ROUTE = "/reports";
export const CONTRACTS_ROUTE = "/contracts";
export const ROLES = [
    "ADMIN",
    "USER",
    "ARTIST"
];

export const OWNER_TYPE = [
    {label: "Авторские", value: "COPYRIGHT"},
    {label: "Смежные", value: "RELATED"}
];